import React, {useEffect, useRef, useState} from 'react';
// @ts-ignore
import Slider from 'react-slick';
import LightGallery from 'lightgallery/react';
import 'lightgallery/scss/lightgallery.scss';
import 'lightgallery/scss/lg-zoom.scss';
import lgZoom from 'lightgallery/plugins/zoom';
import Image from 'next/image'
import { categoryAlias, categoryIdTranslations } from '@/src/app/[locale]/helpers/utils'
import { useTranslations } from 'next-intl'

const ImageSlider = ({ images, estateData }: {images: any, estateData: any}) => {
    const t = useTranslations('')
    const [nav1, setNav1]: any = useState(null);
    const [nav2, setNav2]: any= useState(null);
    const [nav3, setNav3]: any= useState(null);
    const galleryRef: any = useRef(null);
    const [currentSlide, setCurrentSlide]: any = useState(1);
    const slides: any = [...Array(images.length)];

    useEffect(() => {
        const disableRightClick = (e: any) => {
            e.preventDefault();
        };
        document.addEventListener('contextmenu', disableRightClick);
        return () => {
            document.removeEventListener('contextmenu', disableRightClick);
        };
    }, []);

    const handleImageDrag = (e: any) => {
        e.preventDefault();
    };

    function NextArrow(props: any) {
        const { className, onClick } = props;
        return (
          <div
            className={`${className} card-slider-arrow-next`}
            style={{ bottom: "17" }}
            onClick={onClick}
          />
        );
    }

    function PrevArrow(props: any) {
        const { className, onClick } = props;
        return (
          <div
            className={`${className} card-slider-arrow-prev`}
            style={{ bottom: "17" }}
            onClick={onClick}
          />
        );
    }

    const settingsMain = {
        asNavFor: nav2,
        ref: (slider: any) => setNav1(slider),
        arrows: true,
        dots: false,
        infinite: images.length > 1,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (current: any, next: any) => setCurrentSlide(next + 1),
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
    };

    const settingsThumbs = {
        asNavFor: nav1,
        ref: (slider: any) => setNav2(slider),
        slidesToShow: 4,
        swipeToSlide: true,
        focusOnSelect: true,
        vertical: true,
        arrows: false,
        infinite: images.length > 1,
    };

    const settingsMobileThumbs = {
        asNavFor: nav3,
        ref: (slider: any) => setNav3(slider),
        slidesToShow: 2,
        swipeToSlide: true,
        focusOnSelect: true,
        vertical: false,
        arrows: false,
        infinite: images.length > 1,
    };

    const openGallery = (index: number) => {
        galleryRef.current.openGallery(index);
    }

    const thumbnails = images.map((image: any, index: number) => (
        <div key={index} className="thumbnail">
            <Image src={image} width="99" height="100" alt={`${t(categoryIdTranslations[estateData.category])} ${t('Code')} ${estateData.code}`}
                   unoptimized={true} onDragStart={handleImageDrag}/>
        </div>
    ))


    return (
        <div className="slider-container">
            <div className="anti-screenshot-overlay"></div>
            <div className="thumbnail-slider no-mobile">
                <Slider {...settingsThumbs}>
                    {thumbnails}
                </Slider>
            </div>

            <div className="main-slider">
                <Slider {...settingsMain}>
                    {images.map((image: any, index: number) => (
                        <div key={index} data-src={image} className="main-image" onClick={() => openGallery(index)}>
                            <Image src={image} width="661" height="440" alt={`${t(categoryIdTranslations[estateData.category])} ${t('Code')} ${estateData.code}`}
                                   unoptimized={true} onDragStart={handleImageDrag}/>
                        </div>
                    ))}
                </Slider>

                <div
                    className="custom_dots_counter"
                >
                    {currentSlide} / {slides.length}
                </div>
            </div>

            <div className="thumbnail-slider-horizontal mobile">
                <Slider {...settingsMobileThumbs}>
                    {thumbnails}
                </Slider>
            </div>

            <div style={{display: 'none'}}>
                <LightGallery
                    onInit={(gallery: any) => {
                        galleryRef.current = gallery.instance
                    }}
                    licenseKey="AEE75A95-2332-40B1-99F8-7595E5E856E4"
                    plugins={[lgZoom]}
                    download={false}
                    mobileSettings={{
                        showCloseIcon: true,
                        controls: true,
                        download: false
                    }}
                >
                    {images.map((image: any, index: number) => (
                        <div key={index} data-src={image} className="main-image">
                            <Image src={image} width="99" height="100" alt={`${t(categoryIdTranslations[estateData.category])} ${t('Code')} ${estateData.code}`}
                                   unoptimized={true} onDragStart={handleImageDrag}/>
                        </div>
                    ))}
                </LightGallery>
            </div>
        </div>
    );
};

export default ImageSlider;
